import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "How accurate is the AI analysis?",
      answer: "Our AI has been trained on millions of facial images and beauty standards from 50+ countries. It analyzes over 50 facial features including symmetry, proportions, and cultural preferences to provide highly accurate ratings."
    },
    {
      question: "Is my photo stored or shared?",
      answer: "No! Your privacy is our priority. Photos are analyzed in real-time and never stored on our servers. We don't share your data with anyone."
    },
    {
      question: "What's the difference between One-Time and Monthly Pro?",
      answer: "One-Time ($9.99) gives you complete access to all features forever. Monthly Pro ($15/mo) includes everything PLUS new personalized advice every month, the ability to target specific demographics, and monthly progress tracking."
    },
    {
      question: "Can I get a refund?",
      answer: "Yes! We offer a 30-day money-back guarantee. If you're not satisfied with your analysis, contact us at karims11@icloud.com for a full refund."
    },
    {
      question: "How do the demographic insights work?",
      answer: "Our AI compares your features against beauty preferences from different ethnic groups and age ranges. You'll see which demographics find you most attractive and get specific tips to maximize your appeal with each group."
    },
    {
      question: "Will this really help me with dating?",
      answer: "Absolutely! Understanding your strengths and which demographics prefer your look helps you optimize your dating profile, grooming, and approach. Many users report significant increases in matches after implementing our recommendations."
    }
  ];

  return (
    <div className="py-12 max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <HelpCircle className="h-16 w-16 text-purple-400 mx-auto mb-6" />
        </motion.div>
        <h3 className="text-5xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Frequently Asked Questions
        </h3>
        <p className="text-2xl text-gray-300">Everything you need to know</p>
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <AccordionItem 
              value={`item-${index}`}
              className="bg-white/5 backdrop-blur-xl rounded-2xl px-8 border border-white/10 hover:bg-white/10 transition-all"
            >
              <AccordionTrigger className="text-left font-semibold text-xl text-white hover:text-purple-400 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-300 leading-relaxed text-lg pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQ;